import React from "react"
import Footer from "../Components/Outlets/Footer"
import Nav from "../Components/Outlets/Nav"
import banner from "../Assets/campus3.jpg"
import bannerTwo from "../Assets/campus2.jpg"
import { Link } from "react-router-dom"
import { motion } from "framer-motion"

const fadeUp = {
	hidden: { opacity: 0, y: 28 },
	visible: { opacity: 1, y: 0 },
}

const stats = [
	{ value: "+1 & +2", label: "Integrated academics" },
	{ value: "5+", label: "Career pathways" },
	{ value: "100%", label: "Residential campus" },
	{ value: "360°", label: "Student development" },
]

const focusAreas = [
	{
		icon: "ri-graduation-cap-line",
		title: "Academic Excellence",
		text: "Strong senior secondary learning with Science and Commerce options designed for board exam confidence.",
	},
	{
		icon: "ri-book-open-line",
		title: "Entrance Preparation",
		text: "Integrated coaching for NEET, JEE, CA Foundation, CMA Foundation, and other national-level competitive exams.",
	},
	{
		icon: "ri-user-star-line",
		title: "Character & Confidence",
		text: "Mentoring, disciplined routines, and personal growth that help students develop strength of character and future readiness.",
	},
]

const values = ["Excellence", "Confidence", "Integrity", "Empowerment", "Global Mindset"]

const programs = [
	{ title: "Science Stream", sub: "Board + NEET, JEE, KEAM, CUET Coaching", icon: "ri-flask-line" },
	{ title: "Commerce Stream", sub: "Professional Courses & CA, CMA Foundation", icon: "ri-line-chart-line" },
	{ title: "Global University Opportunities", sub: "International Admissions & Scholarship Guidance", icon: "ri-global-line" },
	{ title: "National Entrance Exams", sub: "NEET, JEE, KEAM, CUET & More", icon: "ri-book-open-line" },
]

const quickHighlights = [
	{ icon: "ri-home-heart-line", label: "Residential Campus" },
	{ icon: "ri-shield-star-line", label: "Boys-Only School" },
	{ icon: "ri-award-line", label: "Board & Entrance Prep" },
	{ icon: "ri-team-line", label: "Expert Mentors" },
]

const AboutPage = () => {
	return (
		<div className="about-page-shell">
			<Nav />

			<div className="page-breadcrumb-bar">
				<div className="container-main">
					<div className="breadcrumb-inner">
						<h1 className="breadcrumb-page-title montserrat">About Us</h1>
						<nav className="breadcrumb-nav-links">
							<Link to="/">Home</Link>
							<i className="ri-arrow-right-s-line"></i>
							<span>About Us</span>
						</nav>
					</div>
				</div>
			</div>

			<div className="about-highlights-strip">
				<div className="container-main">
					<div className="about-highlights-row">
						{quickHighlights.map((h, i) => (
							<motion.div
								className="about-highlight-chip"
								key={h.label}
								initial={{ opacity: 0, y: 14 }}
								animate={{ opacity: 1, y: 0 }}
								transition={{ duration: 0.5, delay: i * 0.08 }}
							>
								<i className={h.icon}></i>
								<span>{h.label}</span>
							</motion.div>
						))}
					</div>
				</div>
			</div>

			<main className="about-redesign">
				<section className="about-story-section">
					<div className="container-main">
						<div className="row align-items-center g-5">
							<div className="col-lg-6">
								<motion.div
									className="about-media-grid"
									variants={fadeUp}
									initial="hidden"
									whileInView="visible"
									viewport={{ once: true }}
									transition={{ duration: 0.7 }}
								>
									<div className="about-media-frame about-media-large">
										<img src={bannerTwo} alt="Branmont students on campus" />
									</div>
									<div className="about-media-frame about-media-small">
										<img src={banner} alt="Branmont students collaborating" />
									</div>
									<div className="about-floating-note">
										<i className="ri-shield-star-line"></i>
										<span>Safe, focused, and future-ready learning for boys</span>
									</div>
								</motion.div>
							</div>

							<div className="col-lg-6">
								<motion.div
									className="about-story-copy"
									variants={fadeUp}
									initial="hidden"
									whileInView="visible"
									viewport={{ once: true }}
									transition={{ duration: 0.7, delay: 0.1 }}
								>
									<span className="section-eyebrow">Our Purpose</span>
									<h2 className="section-title montserrat">Built for ambition, care, and clarity</h2>
									<p className="section-copy">
										We help young men move through +1 and +2 with a clear academic plan, strong mentoring,
										and exposure to competitive entrance and professional career routes.
									</p>
									<p className="section-copy">
										Every part of the school experience is designed to build confidence: classroom learning,
										career counseling, communication, emotional wellbeing, and global outlook.
									</p>
									<div className="about-feature-list">
										<div className="about-feature-item">
											<i className="ri-check-line"></i>
											<span>Science and Commerce streams with structured support</span>
										</div>
										<div className="about-feature-item">
											<i className="ri-check-line"></i>
											<span>Entrance coaching integrated with the daily academic rhythm</span>
										</div>
										<div className="about-feature-item">
											<i className="ri-check-line"></i>
											<span>Mentorship for national and global career decisions</span>
										</div>
									</div>
									<Link to="/admission" className="about-cta-link">
										Start your application <i className="ri-arrow-right-line"></i>
									</Link>
								</motion.div>
							</div>
						</div>
					</div>
				</section>

				<section className="about-stat-band">
					<div className="container-main">
						<div className="row g-3">
							{stats.map((stat, index) => (
								<div className="col-lg-3 col-md-6" key={stat.label}>
									<motion.div
										className="about-stat-card"
										variants={fadeUp}
										initial="hidden"
										whileInView="visible"
										viewport={{ once: true }}
										transition={{ duration: 0.5, delay: index * 0.06 }}
									>
										<strong>{stat.value}</strong>
										<span>{stat.label}</span>
									</motion.div>
								</div>
							))}
						</div>
					</div>
				</section>

				<section className="leadership-msg-section">
					<div className="container-main">
						<motion.div
							className="leadership-msg-inner"
							variants={fadeUp}
							initial="hidden"
							whileInView="visible"
							viewport={{ once: true }}
							transition={{ duration: 0.7 }}
						>
							<div className="leadership-msg-label">
								<span className="section-eyebrow">Leadership Message</span>
							</div>
							<div className="leadership-msg-body">
								<div className="leadership-msg-left">
									<div className="leadership-quote-mark">"</div>
									<h2 className="leadership-msg-title montserrat">Managing Director's Message</h2>
									<p className="leadership-msg-name">Basheer Verode House</p>
								</div>
								<div className="leadership-msg-right">
									<p className="leadership-msg-para">
										At Branmont Global Secondary School, we believe that education must open doors to confidence, discipline, independence, and meaningful futures. Our vision is to create a safe, ambitious, and caring residential learning environment where every student discovers his strengths and learns to dream with direction.
									</p>
									<p className="leadership-msg-para">
										In today's fast-changing world, learning must go beyond textbooks and examinations. We combine senior secondary academics with entrance preparation, career guidance, communication skills, leadership training, and real-world exposure so that our students can make informed choices with courage and clarity.
									</p>
									<p className="leadership-msg-para">
										Our commitment is to shape young men who are academically strong, emotionally grounded, socially responsible, and ready for opportunities in India and beyond. With dedicated mentors, modern learning practices, and a values-based campus culture, Branmont stands as a place where every student is encouraged to rise, lead, and succeed.
									</p>
									<div className="leadership-msg-signature">
										<span className="leadership-sig-name">Basheer Verode House</span>
										<span className="leadership-sig-role">Managing Director</span>
									</div>
								</div>
							</div>
						</motion.div>
					</div>
				</section>

				<section className="about-focus-section">
					<div className="container-main">
						<div className="section-heading-row">
							<div>
								<span className="section-eyebrow">What Guides Us</span>
								<h2 className="section-title montserrat">Mission, vision, and daily practice</h2>
							</div>
							<p className="section-copy">
								Our goal is simple: help every student become academically capable, emotionally grounded,
								and confident enough to choose a meaningful future.
							</p>
						</div>

						<div className="row g-4">
							<div className="col-lg-6">
								<motion.div
									className="about-belief-panel mission-panel"
									variants={fadeUp}
									initial="hidden"
									whileInView="visible"
									viewport={{ once: true }}
									transition={{ duration: 0.6 }}
								>
									<i className="ri-compass-3-line"></i>
									<h3>Our Mission</h3>
									<p>
										To provide a structured and supportive learning environment that combines academic excellence, intensive training, and value-based guidance empowering students to achieve their full potential.
									</p>
								</motion.div>
							</div>
							<div className="col-lg-6">
								<motion.div
									className="about-belief-panel vision-panel"
									variants={fadeUp}
									initial="hidden"
									whileInView="visible"
									viewport={{ once: true }}
									transition={{ duration: 0.6, delay: 0.1 }}
								>
									<i className="ri-global-line"></i>
									<h3>Our Vision</h3>
									<p>
										To shape disciplined, confident individuals guided by strong character and moral values, prepared for success in academics and life.
									</p>
								</motion.div>
							</div>
						</div>

						<div className="row g-4 mt-1">
							{focusAreas.map((item, index) => (
								<div className="col-lg-4 col-md-6" key={item.title}>
									<motion.div
										className="about-focus-card"
										variants={fadeUp}
										initial="hidden"
										whileInView="visible"
										viewport={{ once: true }}
										transition={{ duration: 0.55, delay: index * 0.08 }}
									>
										<div className="about-focus-icon">
											<i className={item.icon}></i>
										</div>
										<h3>{item.title}</h3>
										<p>{item.text}</p>
									</motion.div>
								</div>
							))}
						</div>
					</div>
				</section>

				<section className="about-values-section">
					<div className="container-main">
						<div className="values-layout">
							<div className="values-copy">
								<span className="section-eyebrow">Core Values</span>
								<h2 className="section-title montserrat">The culture students feel every day</h2>
							</div>
							<div className="values-list">
								{values.map((value) => (
									<span className="value-chip" key={value}>{value}</span>
								))}
							</div>
						</div>
					</div>
				</section>

				<section className="about-programs-section">
					<div className="container-main">
						<div className="section-heading-center">
							<span className="section-eyebrow">Programs</span>
							<h2 className="section-title montserrat">Career-integrated routes under one roof</h2>
							<p className="section-copy">
								Students can combine senior secondary study with entrance coaching, professional foundations,
								future skills, and global university guidance.
							</p>
						</div>
						<div className="about-program-grid-new">
							{programs.map((program, index) => (
								<motion.div
									key={program.title}
									variants={fadeUp}
									initial="hidden"
									whileInView="visible"
									viewport={{ once: true }}
									transition={{ duration: 0.5, delay: index * 0.08 }}
								>
									<Link to="/acadamics" className="about-program-card-new">
										<div className="about-program-icon-new">
											<i className={program.icon}></i>
										</div>
										<div className="about-program-text">
											<h4>{program.title}</h4>
											<p>{program.sub}</p>
										</div>
										<i className="ri-arrow-right-up-line about-program-arrow-new"></i>
									</Link>
								</motion.div>
							))}
						</div>
					</div>
				</section>

				<section className="about-bottom-cta">
					<div className="container-main">
						<motion.div
							className="about-cta-box"
							variants={fadeUp}
							initial="hidden"
							whileInView="visible"
							viewport={{ once: true }}
							transition={{ duration: 0.6 }}
						>
							<div className="about-cta-text">
								<h2 className="montserrat">Ready to join Branmont?</h2>
								<p>Applications for 2025–26 are open. Limited seats across Science and Commerce streams.</p>
							</div>
							<div className="about-cta-actions">
								<Link to="/admission" className="hero-primary-btn">
									Apply Now <i className="ri-arrow-right-line"></i>
								</Link>
								<Link to="/contact" className="about-cta-outline-btn">
									Contact Admissions
								</Link>
							</div>
						</motion.div>
					</div>
				</section>
			</main>

			<Footer />
		</div>
	)
}

export default AboutPage
